import { css } from 'styled-components';

const flexProp = (prop, alignment) => {
  if (['start', 'end'].includes(prop)) {
    return `flex-${prop}`;
  }

  if (prop === 'spread') {
    if (alignment === 'justify') {
      return 'space-between';
    }

    return 'flex-start';
  }

  return prop;
};

const alignments = ({ orientation, horizontalAlignment, verticalAlignment }) => {
  if (orientation === 'vertical') {
    return css`
      justify-content: ${flexProp(verticalAlignment, 'justify')};
      align-items: ${flexProp(horizontalAlignment, 'align')};
    `;
  }

  return css`
    justify-content: ${flexProp(horizontalAlignment, 'justify')};
    align-items: ${flexProp(verticalAlignment, 'align')};
  `;
};

export default alignments;
